import { Button, Row, Col } from "antd"
import { SaveOutlined, LockOutlined, UnlockOutlined } from "@ant-design/icons"
import { useContext } from "react"
import { PageContext } from "../../../../contexts"
import { useAuth } from "../../../../contexts/auth"

/**
 * Note: This component depends on the global styles defined in the SaveHeader.style.sass file
 */
export function SaveHeader({save, isSaving,submissionStatus, ...props }){
  const { userPermissions } = useContext(PageContext)

  const userCanSave = userPermissions
    ?.SUBMISSIONS
    ?.ALL_SUBMISSIONS_PAGE
    ?.SUBMISSION_EDIT_PAGE
    ?.SAVE_BUTTON

  if (!userCanSave)
    return <Row justify="end" className="fico save-header"><Col></Col></Row>

  const { user } = useAuth()

  const isRejected = submissionStatus === "REJECTED" || submissionStatus == "ON_CLOSURE"

  const isAdminBasic = user?.claims.role === "ADMIN_BASIC" || user?.claims.role === "ADMIN_TECHNICAL_AND_FINANCIAL"

  const shouldHideButton = isRejected && isAdminBasic

  if (shouldHideButton) {
    return null
  }

  return (
    <Row justify="end" className="fico save-header">
      <Col>
        <Button
          icon={<SaveOutlined />}
          loading={isSaving}
          disabled={isSaving}
          onClick={save}
          type="primary"
          {...props}>
          Guardar
        </Button>
      </Col>
    </Row>
  )
}
